<script>
  import { onMount } from "svelte";
	import { api_host, domain_code_store } from "../stores.js";
	import { doFetch } from '../utils/Fetching.svelte';


	let domain_code = '';
	let search_address = '';
	let embed_api_key = '';
	let is_embed_enabled = false;

	domain_code_store.subscribe(value => {
		domain_code = value;
	});

	onMount(async () => {
		const params = new URLSearchParams(window.location.search);
		// if (window.location.ancestorOrigins.length > 0 && params.has('key')) {
		if (params.has('key')) {
			embed_api_key = params.get('key');
			const res = await doFetch(
				`${api_host}/api/landscaper/check/embed_api_key`,
				'POST',
				{ api_key: embed_api_key },
				{ 'DomainCode': domain_code, 'Content-Type': 'application/json' }
			);
			if (res.status) {
				is_embed_enabled = true;
			} else {
				is_embed_enabled = false;
			}
		} else {
			is_embed_enabled = false;
		}
	});

	const handle_address = async () => {
		if (is_embed_enabled) {
			const res = await doFetch(
				`${api_host}/api/ex/property_info`,
				'POST',
				{ q: JSON.stringify(search_address) },
				{ 'DomainCode': domain_code, 'Content-Type': 'application/json' }
			);
			if (res.data) {
				const { address, city, state, lot_size, building_stories } = res.data;
				await doFetch(
					`${api_host}/api/ex/record/search_address`,
					'POST',
					{
						domain_name: window.location.host,
						search_key: search_address,
						lot_size,
						stories: building_stories,
						address,
						city,
						state,
					},
					{ 'DomainCode': domain_code, 'Content-Type': 'application/json' }
				);

				const url = `${window.location.origin}/booking?address_data=${btoa(JSON.stringify(res.data))}`;
				window.parent.postMessage(url, '*');
			} else {
				alert('Invalid Address');
			}
		} else {
			alert('Wrong API Key');
		}
	}
</script>


<div class="formholder">
	<div class='search_container'>
		<center class="search_box_cover">
			<input
				id="search_address"
				type="text"
				name="search"
				placeholder="Search address for instant quote."
				class="c1719"
				on:keyup={(e) => {
					if (e.key === 'Enter') {
						handle_address();
					}
				}}
				bind:value={search_address}
			/>
			<span id="search_address_btn" class="c1734" on:click={(e) => handle_address()}>
				<svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-search">
					<path fill-rule="evenodd" d="M10.442 10.442a1 1 0 011.415 0l3.85 3.85a1 1 0 01-1.414 1.415l-3.85-3.85a1 1 0 010-1.415z" clip-rule="evenodd"></path>
					<path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM13 6.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z" clip-rule="evenodd"></path>
				</svg>
			</span>
		</center>
	</div>
</div>


<style>
	.search_box_cover{
		position:relative;
	}
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas: "pt pt"
												 "mn mn";
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
			margin-left: auto;
			margin-right: auto;
			display: grid;
			grid-template-columns: 1fr;
			grid-template-areas: "pt"
													 "mn";
		}
	}
	.search_container {
		margin-top: 15px;
		grid-area: mn;
	}
	.search_container input[type=text] {
    font-size: 17px;
    border: 1px solid grey;
    float: left;
    width: 100%;
    background: #ffffff;
    border-radius: 10px;
		padding: 10px 45px 9px 10px;
	}
	.search_container::after {
		content: "";
		clear: both;
		display: table;
	}
	#search_address_btn {
		position: absolute;
    top: 10px;
    right: 15px;
	}
</style>